/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class Cache {
    getter;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    constructor(getter) {
        this.getter = getter;
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    get v() {
        const value = this.getter();
        Object.defineProperty(this, 'v', {
            configurable: false,
            enumerable: false,
            writable: false,
            value,
        });
        // @ts-expect-error Make sure we can garbage collect the function.
        this.getter = undefined;
        return value;
    }
}
